import {MoreResultsAvailableBanner as MoreResultsAvailableBannerDisplay} from '@github-ui/issues-shared/more-results-available-banner'
import {VALUES} from '@github-ui/issues-shared/values'
import {isPrsOnly} from '@github-ui/list-view-items-issues-prs/Query'
import {useUser} from '@github-ui/use-user'
import {useMemo} from 'react'

import {useActiveSearchQuery} from '../../contexts/QueryContext'

export type MoreResultsAvailableBannerProps = {
  itemsLabel: string
}

export const MoreResultsAvailableBanner = ({itemsLabel}: MoreResultsAvailableBannerProps) => {
  const activeSearchQuery = useActiveSearchQuery()
  const {currentUser} = useUser()

  const onlyPrs = useMemo(() => isPrsOnly(activeSearchQuery), [activeSearchQuery])
  return (
    <MoreResultsAvailableBannerDisplay
      itemsLabel={itemsLabel}
      maxItems={VALUES.maxIssuesListItems(onlyPrs, !!currentUser)}
    />
  )
}
